import * as S from "./commonStyles";
import AddressIcon from "assets/category-icon.svg";
import ProductIcon from "assets/product.svg";
import BeneficiaryIcon from "assets/beneficiary.svg";
import { calculateDistance } from "utils/calculateDistance";
import { useReport } from "contexts/ReportContext";

export function PolicemanTab() {
  const { report } = useReport();

  function renderDistance() {
    if (!report) {
      return <p>--</p>;
    }

    if (report.starterCoords && report.finishCoords) {
      try {
        const starterCoords = JSON.parse(report.starterCoords);
        const finishCoords = JSON.parse(report.finishCoords);

        const distance = calculateDistance(
          { lat: starterCoords[0], lng: starterCoords[1] },
          { lat: finishCoords[0], lng: finishCoords[1] }
        );

        return <S.Distance>{(distance / 1000).toFixed(2)}km</S.Distance>;
      } catch {
        return <p>--</p>;
      }
    }

    return <p>--</p>;
  }

  function checkArrivalDate() {
    if (report?.arrivalTime && report?.estimatedArrival) {
      const arrivalTime = new Date(report?.arrivalTime);
      const estimatedTime = new Date(report?.estimatedArrival);
      if (arrivalTime <= estimatedTime) {
        return <S.OnTime>Chegou à tempo</S.OnTime>;
      } else {
        return <S.IsLate>Atrasado</S.IsLate>;
      }
    }
  }

  return (
    <S.Container>
      <S.Row>
        <h2>
          <img src={AddressIcon} alt="img" /> Pronta-resposta
        </h2>
        <S.Flex>
          <div>
            <p>Nome</p>
            <h3>{report?.policeman?.user?.name || "-"} </h3>
          </div>
          <div>
            <p>Valor recebido(REC)</p>
            <h3>{report?.rec === null ? "-" : report?.rec}</h3>
          </div>
          <div>
            <p>Valor a pagar ao PR</p>
            <h3>{report?.pr === null ? "-" : report?.pr}</h3>
          </div>
        </S.Flex>
      </S.Row>
      <S.Row>
        <h2>
          <img src={ProductIcon} alt="img" /> Deslocação
        </h2>
        <S.Flex>
          <div>
            <p>Estimativa de chegada</p>
            <h3>
              {report?.estimatedArrival
                ? new Date(report?.estimatedArrival).toLocaleDateString(
                    "pt-BR",
                    {
                      day: "2-digit",
                      month: "short",
                      year: "numeric",
                      hour: "2-digit",
                      minute: "2-digit",
                    }
                  )
                : "-"}
            </h3>
          </div>
          <div>
            <p>Data e hora de chegada</p>
            <h3>
              {report?.arrivalTime
                ? new Date(report?.arrivalTime).toLocaleDateString("pt-BR", {
                    day: "2-digit",
                    month: "short",
                    year: "numeric",
                    hour: "2-digit",
                    minute: "2-digit",
                  })
                : "-"}
            </h3>
          </div>
          <div>
            <p>Chegou à tempo?</p>
            <h3>{checkArrivalDate()}</h3>
          </div>
        </S.Flex>
      </S.Row>
      <S.Row>
        <h2>
          <img src={BeneficiaryIcon} alt="img" /> Coordenadas do Hodômetro
        </h2>
        <S.Flex>
          <div>
            <p>Hodômetro inicial</p>
            <h3>{report?.starterCoords ? "-" : report?.starterCoords}</h3>
          </div>
          <div>
            <p>Hodômetro final</p>
            <h3>{report?.finishCoords ? "-" : report?.finishCoords}</h3>
          </div>
          <div>
            <p>Total percorrido (aprox.)</p>
            <h3>{renderDistance()}</h3>
          </div>
        </S.Flex>
      </S.Row>
    </S.Container>
  );
}
